import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `SystemV2Page`.
 */
const LoadablePage = loadable(
  () => import(/* webpackChunkName: "SystemV2Page" */ "."),
  {
    fallback: <LinearProgress />,
  }
);

export default LoadablePage;
